import isRunningOnClient from './is-running-on-client';

interface Breakpoints {
  [key: string]: number;
}

const responsiveValue = <T>(breakpoints: Breakpoints = {}): T | undefined => {
  if (!isRunningOnClient) {
    return undefined;
  }

  const activeBreakpoint = Object.entries(breakpoints)
    .filter(([breakpoint]) => window.matchMedia(`(min-width: ${breakpoint})`).matches)
    .pop();

  if (activeBreakpoint) {
    const [, value] = activeBreakpoint;
    return value as T;
  }

  return undefined;
};

export default responsiveValue;
